import { FileDownloadService } from "@topline/services/fileDownloadService";
import { angularServicesNames } from "@topline/services/angularServicesNames";
import { ToasterService } from "@topline/services/toasterService";

(module => {
    "use strict";

    module.component("forecastAbsoluteDifferences", {
        template: require("./forecastAbsoluteDifferencesComponent.html"),
        bindings: {
            pmForecast: "<",
            statisticalForecast: "<",
            parameters: "<",
            showYears: "<",
            showCycles: "<"
        },
        controller: [
            "$scope",
            angularServicesNames.$translate,
            "$timeout",
            "absoluteDifferencesService",
            "PPGChartAndTableService",
            "calculationPPGService",
            ToasterService.componentName,
            FileDownloadService.componentName,
            function (
                this: $TSFixMe,
                $scope: $TSFixMe,
                $translate: ng.translate.ITranslateService,
                $timeout: ng.ITimeoutService,
                absoluteDifferencesService: $TSFixMe,
                PPGChartAndTableService: $TSFixMe,
                calculationPPGService: $TSFixMe,
                toasterService: ToasterService,
                fileDownloadService: FileDownloadService
            ) {
                const $ctrl = this;

                function calculateAbsoluteDifferences() {
                    if (
                        !angular.isUndefinedOrNull($ctrl.statisticalForecast) &&
                        !angular.isUndefinedOrNull($ctrl.pmForecast)
                    ) {
                        let sumStatisitcalYearly = calculationPPGService.sumBy(
                                $ctrl.statisticalForecast,
                                $ctrl.parameters.forecastStartDate,
                                (month: $TSFixMe) => month == 0
                            ),
                            sumPmForecastYearly = calculationPPGService.sumBy(
                                $ctrl.pmForecast,
                                $ctrl.parameters.forecastStartDate,
                                (month: $TSFixMe) => month == 0
                            ),
                            sumStatisticalQuarters = calculationPPGService.sumBy(
                                $ctrl.statisticalForecast,
                                $ctrl.parameters.forecastStartDate,
                                (month: $TSFixMe) => month % 3 == 0
                            ),
                            sumPmForecastQuarters = calculationPPGService.sumBy(
                                $ctrl.pmForecast,
                                $ctrl.parameters.forecastStartDate,
                                (month: $TSFixMe) => month % 3 == 0
                            ),
                            sumStatisticalCycles = calculationPPGService.sumBy(
                                $ctrl.statisticalForecast,
                                $ctrl.parameters.forecastStartDate,
                                (month: $TSFixMe) => {
                                    return month % 4 == 0;
                                }
                            ),
                            sumPmForecastCycles = calculationPPGService.sumBy(
                                $ctrl.pmForecast,
                                $ctrl.parameters.forecastStartDate,
                                (month: $TSFixMe) => {
                                    return month % 4 == 0;
                                }
                            );

                        let absoluteDiffForecastYearly = absoluteDifferencesService.calculateAbsoluteDiffForecast(
                                sumPmForecastYearly,
                                sumStatisitcalYearly
                            ),
                            absoluteDiffForecastQuarters = absoluteDifferencesService.calculateAbsoluteDiffForecast(
                                sumPmForecastQuarters,
                                sumStatisticalQuarters
                            ),
                            absoluteDiffForecastCycles = absoluteDifferencesService.calculateAbsoluteDiffForecast(
                                sumPmForecastCycles,
                                sumStatisticalCycles
                            );

                        $ctrl.dataToDisplayYearlyTable = [
                            {
                                header: $translate.instant("FORECAST.PRODUCT.PACKAGE_MARKET"),
                                data: absoluteDiffForecastYearly
                            }
                        ];

                        $ctrl.dataToDisplayQuarter = [
                            {
                                header: $translate.instant("FORECAST.PRODUCT.PACKAGE_MARKET"),
                                data: absoluteDiffForecastQuarters
                            }
                        ];

                        $ctrl.dataToDisplayCycles = [
                            {
                                header: $translate.instant("FORECAST.PRODUCT.PACKAGE_MARKET"),
                                data: absoluteDiffForecastCycles
                            }
                        ];
                    }
                }

                $ctrl.$onInit = () => {
                    $scope.$watchGroup(["$ctrl.pmForecast", "$ctrl.statisticalForecast"], (newVal: $TSFixMe) => {
                        if (newVal) {
                            calculateAbsoluteDifferences();
                        }
                    });

                    $ctrl.labels = PPGChartAndTableService.prepareLabelsToPPG(
                        $ctrl.parameters.forecastStartDate,
                        $ctrl.parameters.forecastEndDate
                    );
                };

                $ctrl.exportTable = () => {
                    toasterService.showReportGenerateBusyIndicator(
                        () =>
                            fileDownloadService.exportTable("table.xlsx", {
                                columns: _.map($ctrl.labels, e => e),

                                rows: _.map($ctrl.dataToDisplayYearlyTable, (x: $TSFixMe) => {
                                    return {
                                        header: x.header,
                                        values: x.data,
                                        decimalPlaces: 0
                                    };
                                })
                            }),
                        "EXCEL_EXPORT_GENERATING",
                        "EXCEL_EXPORT_GENERATED"
                    );
                };
            }
        ]
    });
})(angular.module("topline.modules"));
